import { Route, Routes } from 'react-router-dom';
import IncidentDetailsWrapper from './incident-detail/IncidentDetailsWrapper';
import LocationIncidentsList from './location-incidents-list/LocationIncidentsList';

export function LocationIncidentsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LocationIncidentsList />} />
      <Route
        path="/incident/:alarmId"
        element={<IncidentDetailsWrapper product="remote-guarding" />}
      />
      <Route
        path="/scan/:alarmId"
        element={<IncidentDetailsWrapper product="scan" />}
      />
    </Routes>
  );
}

export default LocationIncidentsRoutes;
